import React, { FC, useCallback, useContext } from 'react';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import NolBottomSheet from '../NolBottomSheet';

const SignUpCompleteBottomSheet: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  const onClick = useCallback(() => {
    store.onVersion3TabClick(0);
    store.isSignUpCompleteOpen = false;
  }, []);

  return (
    <NolBottomSheet
      isOpen={store.isSignUpCompleteOpen}
      onRequestClose={() => (store.isSignUpCompleteOpen = false)}
      title={'NOL 카드 가입 완료'}
      body={{
        description:
          '놀수록 놀라운 혜택! NOL 카드 신청이 완료되었습니다.\n첫 가입 쿠폰을 비롯한 다양한 혜택을 확인해보세요.',
      }}
      button={{ label: '혜택 확인하기', onClick }}
    />
  );
};

export default observer(SignUpCompleteBottomSheet);
